import { ILoadUserContacts } from 'domain/usecases/user/load-contacts'
import { UserRepository } from 'repository/repositories/user/user-repository'

export class RemoteLoadUserContacts implements ILoadUserContacts {
  private readonly userRepository: UserRepository

  constructor(userRepository: UserRepository) {
    this.userRepository = userRepository
  }

  async load(
    params: ILoadUserContacts.Params
  ): Promise<ILoadUserContacts.Model> {
    return this.userRepository.loadContacts(params)
  }
}
